import { Client, setAccessToken } from "../api";
import {
  showLoading,
  showError,
  setClientValue,
  increaseStepByOne,
  decreaseStepByOne,
} from "../actions";
import { encodePassword } from '../helpers';

const saveClientData = (client, dispatch) => {
  const { name, ci, rut, mail, mobilePhoneNumber } = client;

  dispatch(setClientValue('name', name));
  dispatch(setClientValue('email', mail));
  dispatch(setClientValue('phoneNumber', mobilePhoneNumber));
  
  if (ci != null && ci != "") {
    dispatch(setClientValue('documentType', "1"));
    dispatch(setClientValue('documentNumber', ci));
  }
  if ((ci == null || ci == "") && rut != null && rut != "") {
    dispatch(setClientValue('documentType', "2"));
    dispatch(setClientValue('documentNumber', rut));
  }
  
  dispatch(increaseStepByOne());
}

export function login(password) {
  return (dispatch, getState) => {
    const { client } = getState();
    const { email } = client;
    const passEncoded = encodePassword(password);

    dispatch(showLoading(true));
    const request = Object.assign({}, { email, passEncoded });

    return Client.login(request).then(response => {
      if (response && response.success) {
        setAccessToken(response.token);
        saveClientData(response.client, dispatch)
      } else {
        dispatch(setClientValue('errorMessage', response.message));
      }
      dispatch(showLoading(false));
    });
  };
}

export function getClientByMail(email) {
  return (dispatch, getState) => {

    dispatch(showLoading(true));
    
    return Client.getClientByMail(email).then(response => {
      if (response && response.success) {
        saveClientData(response.client, dispatch)
      }
      dispatch(showLoading(false));
    });
  };
}

export function sendPolicyDocuments() {
  return (dispatch, getState) => {
    const { yates, quotation } = getState();
    const { files, filesComments } = yates;
    const { quoteId } = quotation;

    dispatch(showLoading(true));

    let policyDocuments = [];
    for(let i = 0; i < 3; i++) {
      if(files[i]) {
        policyDocuments.push({
          "name": files[i].name,
          "type": files[i].data.split(',')[0],
          "buffer": files[i].data.split(',')[1],
          "comment": filesComments[i],
        });
      }
    }
    
    const request = Object.assign({}, { "quoting": "yates", quoteId, "policyDocuments": JSON.stringify(policyDocuments) });
    return Client.sendPolicyDocuments(request).then(response => {
      if (!response) { 
        dispatch(showError(true)); 
        dispatch(decreaseStepByOne()); 
      }
      dispatch(showLoading(false));
    });
  };
}


export function sendQuoteByEmail(type) {
  return (dispatch, getState) => {

    const { client, quotation } = getState();
    
    const data = {
      type, client,
      quoteId: quotation.quoteId,
    };
    dispatch(showLoading(true));

    const request = Object.assign({}, { ...data });
    return Client.sendQuoteByEmail(request).then(response => {
      // if (response && response.sended === 1) { } 
      dispatch(showLoading(false));
      // console.log("sendQuoteByEmail", response);
    });
  };
}